import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=41968aec&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=41968aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41968aec",
  null
  
)

export default component.exports
import {QPageContainer,QCard,QCardSection,QAvatar,QIcon,QChip,QBtn,QTooltip,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QBadge,QInput,QMarkupTable,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QCardSection,QAvatar,QIcon,QChip,QBtn,QTooltip,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QBadge,QInput,QMarkupTable,QField})
